import React from 'react';
import AssetTypeCodeList from '../../components/assettypecodecomponents/AssetTypeCodeList';
import { useSelector } from 'react-redux';

function AssetTypeCodeDetails({ renderPageContent }) {

    const headerName= useSelector(state => state.authendicationReducer.headerName); 

    if (headerName === 'Hospital Masters') {
        return (
            <>
                {/*Dynamic content goes here */}
                <AssetTypeCodeList renderPageContent={renderPageContent} />
            </>
        );
    } else {
        // If headerName doesn't match, return null or any other desired behavior
        return null; // or any other fallback component
    }
}

export default AssetTypeCodeDetails;

